import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=6cc2608c&"
import script from "./Wizard.vue?vue&type=script&lang=js&"
export * from "./Wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cc2608c')) {
      api.createRecord('6cc2608c', component.options)
    } else {
      api.reload('6cc2608c', component.options)
    }
    module.hot.accept("./Wizard.vue?vue&type=template&id=6cc2608c&", function () {
      api.rerender('6cc2608c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/Wizard.vue"
export default component.exports